import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Injectable, inject } from '@angular/core';

import { ApValidDateValidator } from '@ap/input/validators';

import { ApPersonalDetailsLimitedService } from '../personal-details-limited/personal-details-limited.service';

import { PersonalDetailsVkgLimited, PersonalDetailsVkgLimitedForm } from './personal-details-vkg-limited.model';

/** The ApPersonalDetailsService is used to create a formGroup. To be used with {@link ApPersonalDetailsComponent} */
@Injectable()
export class ApPersonalDetailsVkgLimitedService {
    private readonly personalDetailsLimitedService = inject(ApPersonalDetailsLimitedService);

    public createFormGroup(personalDetailsVkgLimited: PersonalDetailsVkgLimited): FormGroup<PersonalDetailsVkgLimitedForm> {
        const personalDetailsVkgLimitedForm = new FormGroup<PersonalDetailsVkgLimitedForm>({
            dateOfBirth: new FormControl(personalDetailsVkgLimited.dateOfBirth, {
                validators: [Validators.required, ApValidDateValidator.validate]
            })
        });
        this.personalDetailsLimitedService.addToFormGroup(personalDetailsVkgLimitedForm, personalDetailsVkgLimited);
        return personalDetailsVkgLimitedForm;
    }

    public addToFormGroup(formGroup: FormGroup, personalDetailsVkgLimited: PersonalDetailsVkgLimited): void {
        const newFormGroup = this.createFormGroup(personalDetailsVkgLimited);
        Object.keys(newFormGroup.controls).forEach((key) => formGroup.addControl(key, newFormGroup.controls[key]));
    }
}
